import service from '@/utils/server';

const modName = '/log/waybill/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//明细
export const detail = data => {
  return service({
    url: modName + 'detail/' + data,
    method: 'post',
  });
};

//重推
export const rePush = data => {
  return service({
    url: modName + 'rePush',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/log/waybill/api/index.js